import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ClipboardList, FileText, LayoutDashboard, Menu } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ErpCopilot } from './ErpCopilot';
import { useAuth } from '../../hooks/useAuth';

export const DashboardLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { hasPermission } = useAuth();

  const mobileItems = [
    { path: '/', label: 'Início', icon: LayoutDashboard },
    { path: '/documentos', label: 'Documentos', icon: FileText, permission: 'documentos:read' },
    { path: '/revisoes', label: 'Revisões', icon: ClipboardList, permission: 'revisoes:read' },
  ].filter((item) => !item.permission || hasPermission(item.permission));

  return (
    <div className="min-h-screen bg-nexus-darker">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {mobileMenuOpen && (
        <>
          <button
            type="button"
            aria-label="Fechar menu"
            onClick={() => setMobileMenuOpen(false)}
            className="fixed inset-0 z-[80] bg-slate-950/70 backdrop-blur-sm lg:hidden"
          />
          <Sidebar mobile onMobileClose={() => setMobileMenuOpen(false)} />
        </>
      )}

      {/* Header */}
      <Header sidebarCollapsed={sidebarCollapsed} onMobileMenu={() => setMobileMenuOpen(true)} />

      {/* Main Content */}
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.2 }}
        className={
          sidebarCollapsed 
            ? 'min-h-screen pt-16 pb-24 lg:pl-20 lg:pt-20 lg:pb-0'
            : 'min-h-screen pt-16 pb-24 lg:pl-72 lg:pt-20 lg:pb-0'
        }
      >
        <div className="p-4 sm:p-6">
          <Outlet />
        </div>
      </motion.main>

      <nav className="fixed inset-x-0 bottom-0 z-[70] flex items-stretch border-t border-white/10 bg-slate-950/95 px-2 pb-[max(env(safe-area-inset-bottom),0.5rem)] pt-2 backdrop-blur-xl lg:hidden">
        {mobileItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) => `flex min-h-14 flex-1 flex-col items-center justify-center gap-1 rounded-lg text-[11px] font-medium ${isActive ? 'bg-accent-primary/15 text-white' : 'text-white/55'}`}
            >
              <Icon className="h-5 w-5" />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
        <button type="button" onClick={() => setMobileMenuOpen(true)} className="flex min-h-14 flex-1 flex-col items-center justify-center gap-1 rounded-lg text-[11px] font-medium text-white/55" aria-label="Abrir menu">
          <Menu className="h-5 w-5" />
          <span>Menu</span>
        </button>
      </nav>
      <ErpCopilot />
    </div>
  );
};

export default DashboardLayout;
